function Footer() {
  return <div className="w-full h-28"></div>
}

export default Footer
